export var getRefundTypes = function (data) {
    var refundTypes = [];
    var keys = Object.keys(data);
    for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        if (key.endsWith("_id") && data[key] !== 0) {
            var typeKey = key.replace("_id", "_type");
            if (typeof data[typeKey] === "string" && data[typeKey] !== "") {
                refundTypes.push({
                    id: data[key],
                    name: data[typeKey],
                });
            }
        }
    }
    return refundTypes;
};
